/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Aria_LabelInputs */

const en_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align text left`)
};

const fr_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner le texte a gauche`)
};

const de_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text linksbündig ausrichten`)
};

const it_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea il testo a sinistra`)
};

const ru_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание текста по левому краю`)
};

const es_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear el texto a la izquierda`)
};

const zh_cn2_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本左对齐`)
};

const ja_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを左揃えにする`)
};

const hi_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को बाईं ओर संरेखित करें`)
};

const pt_pt2_align_left_aria_label = /** @type {(inputs: Align_Left_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhar texto à esquerda`)
};

/**
* | output |
* | --- |
* | "Align text left" |
*
* @param {Align_Left_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_aria_label = /** @type {((inputs?: Align_Left_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_left_aria_label(inputs)
	if (locale === "de") return de_align_left_aria_label(inputs)
	if (locale === "it") return it_align_left_aria_label(inputs)
	if (locale === "ru") return ru_align_left_aria_label(inputs)
	if (locale === "es") return es_align_left_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_align_left_aria_label(inputs)
	if (locale === "ja") return ja_align_left_aria_label(inputs)
	if (locale === "hi") return hi_align_left_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_align_left_aria_label(inputs)
	return en_align_left_aria_label(inputs)
});